// extracted by mini-css-extract-plugin
module.exports = {"HorizLine":"HorizLine_HorizLine__2q4Vg"};